export default "__VITE_ASSET__BnqneRg0__"